'use strict';

// eslint-disable-next-line max-lines-per-function
angular.module('webAgro1App').factory('ChartsService', function($filter, $timeout) {
  const removeInactiveStands = function(array) {
    if (array[0].objeto.stand) {
      return array.filter(function(element) {
        return element.objeto.registroAtivo;
      });
    }
    return array;
  };

  return {
    adjustAllCharts: function() {
      const _this = this;

      $('.highcharts-container').each(function() {
        const $elemento = $(this);
        _this.adjustChart($elemento.parent(), $elemento.parent());
      });
    },

    adjustChart: function(container, containerChart) {
      if ($(containerChart).highcharts()) {
        $(containerChart).highcharts()
          .setSize($(container).width(), $(container).height(), true);
      }
    },

    // eslint-disable-next-line max-lines-per-function
    loaderChartStandProductivity: function(data, container, containerChart) {
      if ($(containerChart).highcharts()) {
        $(containerChart).highcharts()
          .destroy();
      }
      if (data.length > 0) {
        data = removeInactiveStands(data);
        const isProdutividade = data[0].produtividade;

        const serie1 = [];
        const serie2 = [];
        const xSeries = [];
        for (let i = 0; i <= data.length-1; i++) {
          serie1.push(Number([data[i].ideal]));
          serie2.push(Number([data[i].realized]));
          const wSerie = [];
          wSerie.push(i+1);
          wSerie.push(data[i].index);
          xSeries.push(wSerie);
        }

        const _this = this;

        // eslint-disable-next-line max-lines-per-function
        $(function() {
          $(containerChart).highcharts({
            chart: {
              backgroundColor: null,
              spacingLeft: 5,
              spacingRight: 5,
              spacingBottom: 5
            },
            credits: { text: '', href: '' },
            title: { text: '' },
            subtitle: { text: '' },
            xAxis: { tickInterval: 1 },
            yAxis: {
              title: {
                text: ''
              },
              gridLineColor: '#6D869F',
              labels: {
                format: '{value}',
                align: 'right',
                x: 0,
                y: 0
              },
              tickInterval: isProdutividade ? 5 : 10000
            },
            legend: {
              layout: 'vertical',
              align: 'right',
              verticalAlign: 'middle',
              borderWidth: 0
            },
            plotOptions: {
              series: {
                fillOpacity: 0.2,
                pointStart: 1,
                cursor: 'pointer',
                point: {
                  events: {
                    click: () => null
                  }
                }
              }
            },
            tooltip: {
              useHTML: true,
              formatter: function() {
                let s = `${'<table>'+
                        '  <thead>'+
                        '    <tr>'+
                        '      <th colspan="2" style="text-align:center">'+
                        '       <h5><b>Ponto '}${ this.x }</b></h5>`+
                        '      </th>'+
                        '    </tr>'+
                        '  </thead>'+
                        '  <tbody>';
                for (const index in this.points) {
                  s += `${'<tr>'+
                       '  <td style="text-align: right;color: '}${ this.points[index].series.color }">
                            <b>${ this.points[index].series.name }:</b>
                          </td>`+
                       `  <td style="text-align: right;color: ${ this.points[index].series.color }">`+
                       `    &nbsp;&nbsp; ${ $filter('number')(this.points[index].y) } ${ data[0].unitDescription
                       }  </td>`+
                       '</tr>';
                }
                s += '  </tbody>'+
                     '</table>';
                return s;
              },
              valueDecimals: 0,
              crosshairs: {
                width: 2,
                color: 'gray',
                dashStyle: 'shortdot'
              },
              backgroundColor: {
                linearGradient: [0, 0, 0, 60],
                stops: [
                  [0, '#E0E0E0'],
                  [1, '#FFFFFF']
                ]
              },
              borderRadius: 10,
              borderColor: 'black',
              borderWidth: 1,
              shared: true
            },
            series: [
              {
                name: 'Realizada',
                data: serie2,
                type: 'column',
                color: '#00BB00'
              },
              {
                name: isProdutividade ? 'Meta' : 'Ideal',
                data: serie1,
                type: 'line',
                color: '#000099',
                marker: {
                  enabled: false
                }
              }
            ]
          });
          $timeout(function() {
            _this.adjustChart(container, containerChart);
          }, 1000);
        });
      }
    },

    // eslint-disable-next-line max-lines-per-function
    loaderChartProductivityStadiums: function(scope, container, containerChart) {
      $(container).hide();
      if ($(containerChart).highcharts()) {
        $(containerChart).highcharts()
          .destroy();
      }
      if (scope.productivityStadiums.length > 0) {
        const serie1 = [];
        const serie2 = [];
        const xSeries = [''];
        for (let i = 0; i <= scope.productivityStadiums.length-1; i++) {
          serie1.push([scope.productivityStadiums[i].ideal]);
          serie2.push([scope.productivityStadiums[i].estimada]);
          xSeries.push(scope.productivityStadiums[i].descricao);
        }
        const _this = this;

        // eslint-disable-next-line max-lines-per-function
        $(function() {
          $(containerChart).highcharts({
            chart: {
              backgroundColor: null,
              spacingLeft: 5,
              spacingRight: 5,
              spacingBottom: 5
            },
            credits: { text: '', href: '' },
            title: { text: '' },
            subtitle: { text: '' },
            xAxis: {
              categories: xSeries
            },
            yAxis: {
              title: {
                text: ''
              },
              gridLineColor: '#6D869F',
              labels: {
                format: '{value} sc/ha ',
                align: 'right',
                x: 0,
                y: 0
              },
              tickInterval: 5
            },
            legend: {
              layout: 'vertical',
              align: 'right',
              verticalAlign: 'middle',
              borderWidth: 0
            },
            plotOptions: {
              series: {
                fillOpacity: 0.2,
                pointStart: 1,
                cursor: 'pointer'
              }
            },
            tooltip: {
              useHTML: true,
              formatter: function() {
                let s = `${'<table>'+
                        '  <thead>'+
                        '    <tr><th colspan="2" style="text-align:center"><h5><b>'}${ this.x }</b></h5></th></tr>`+
                        '  </thead>'+
                        '  <tbody>';
                for (const index in this.points) {
                  s += `${'<tr>'+
                       '  <td style="text-align: right;color: '}${ this.points[index].series.color }">
                            <b>${ this.points[index].series.name }:</b>
                          </td>`+
                       `  <td style="text-align: right;color: ${ this.points[index].series.color }">`+
                       `    &nbsp;&nbsp; ${ $filter('number')(this.points[index].y) } sc/ha`+
                       '  </td>'+
                       '</tr>';
                }
                s += '  </tbody>'+
                     '</table>';
                return s;
              },
              valueDecimals: 0,
              crosshairs: {
                width: 2,
                color: 'gray',
                dashStyle: 'shortdot'
              },
              backgroundColor: {
                linearGradient: [0, 0, 0, 60],
                stops: [
                  [0, '#E0E0E0'],
                  [1, '#FFFFFF']
                ]
              },
              borderRadius: 10,
              borderColor: 'black',
              borderWidth: 1,
              shared: true
            },
            series: [
              {
                name: 'Realizada',
                data: serie2,
                type: 'column',
                color: '#00BB00'
              },
              {
                name: 'Meta',
                data: serie1,
                type: 'line',
                color: '#000099',
                marker: {
                  enabled: false
                }
              }
            ]
          });
          $timeout(function() {
            $(container).show();
            _this.adjustChart(container, containerChart);
          }, 1000);
        });
      }
    },

    // eslint-disable-next-line max-lines-per-function
    loaderChartOccurrency: function(data, container, containerChart) {
      if ($(containerChart).highcharts()) {
        $(containerChart).highcharts()
          .destroy();
      }
      if (data.length > 0) {
        const status = {
          equilibrio: 1,
          atencao: 2,
          emergencia: 3
        };
        const statusDescription = ['', 'Baixa', 'Média', 'Alta'];

        const serie1 = [];
        for (let i = 0; i <= data.length-1; i++) {
          if (data[i].status) {
            serie1.push([status[data[i].status] || status.equilibrio]);
          }
        }

        const _this = this;

        // eslint-disable-next-line max-lines-per-function
        $(function() {
          $(containerChart).highcharts({
            chart: {
              backgroundColor: null,
              spacingLeft: 5,
              spacingRight: 5,
              spacingBottom: 5
            },
            credits: { text: '', href: '' },
            title: { text: '' },
            subtitle: { text: '' },
            xAxis: { tickInterval: 1 },
            yAxis: {
              title: {
                text: ''
              },
              labels: {
                enabled: false
              },
              gridLineWidth: -1,
              plotLines: [
                {
                  value: 1,
                  color: '#2ECC71',
                  dashStyle: 'shortdash',
                  width: 2,
                  label: {
                    text: statusDescription[1]
                  },
                  zIndex: 999
                },
                {
                  value: 2,
                  color: '#e6b500',
                  dashStyle: 'shortdash',
                  width: 2,
                  label: {
                    text: statusDescription[2]
                  },
                  zIndex: 999
                },
                {
                  value: 3,
                  color: '#e74c3c',
                  dashStyle: 'shortdash',
                  width: 2,
                  label: {
                    text: statusDescription[3]
                  },
                  zIndex: 999
                }
              ]
            },
            legend: {
              enabled: false
            },
            plotOptions: {
              series: {
                fillOpacity: 0.2,
                pointStart: 1,
                pointWidth: 5,
                cursor: 'pointer',
                point: {}
              }
            },
            tooltip: {
              enabled: false
            },
            series: [
              {
                name: 'Status',
                data: serie1,
                type: 'column',
                color: '#777777'
              }
            ]
          });
          $timeout(function() {
            _this.adjustChart(container, containerChart);
          }, 1000);
        });
      }
    },

    // NOVOS GRÁFICOS //
    // eslint-disable-next-line max-lines-per-function, complexity
    loaderStandProductivity: function(data, container, containerChart) {
      if ($(containerChart).highcharts()) {
        $(containerChart).highcharts()
          .destroy();
      }

      if (data.length > 0) {
        data = removeInactiveStands(data);

        const isProdutividade = data[0].objeto.produtividade;
        const serie1 = [];
        const serie2 = [];
        for (let i = 0; i <= data.length-1; i++) {
          serie1
            .push(
              Number(
                Number((data[i].marker || data[i].objeto).ideal)
                  .toFixed((data[i].marker || data[i].objeto).produtividade ? 2 : 0)
              ),
            );
          serie2.push({
            y: Number(Number((data[i].marker || data[i].objeto).realized)
              .toFixed((data[i].marker || data[i].objeto).produtividade ? 2 : 0)),
            color: (data[i].marker || data[i].objeto).color
          });
        }

        const _this = this;

        // eslint-disable-next-line max-lines-per-function
        $(function() {
          $(containerChart).highcharts({
            chart: {
              backgroundColor: null,
              spacingLeft: 5,
              spacingRight: 5,
              spacingBottom: 5
            },
            credits: { text: '', href: '' },
            title: { text: '' },
            subtitle: { text: '' },
            xAxis: { tickInterval: 1 },
            yAxis: {
              title: {
                text: ''
              },
              gridLineColor: '#6D869F',
              labels: {
                align: 'right',
                x: 0,
                y: 0
              },
              tickInterval: isProdutividade ? 5 : 10000
            },
            legend: {
              enabled: false
            },
            plotOptions: {
              series: {
                fillOpacity: 0.2,
                pointStart: 1,
                cursor: 'pointer',
                point: {
                  events: {
                    click: () => null
                  }
                }
              }
            },
            tooltip: {
              useHTML: true,
              formatter: function() {
                let s = `${'<table>'+
                        '  <thead>'+
                        '    <tr><th colspan="2" style="text-align:center">'+
                        '     <h5><b>Ponto '}${ this.x }</b></h5></th>
                             </tr>`+
                        '  </thead>'+
                        '  <tbody>';
                for (const index in this.points) {
                  s += `${'<tr>'+
                       '  <td style="text-align: right;color: '}${ this.points[index].color }">
                            <b>${ this.points[index].series.name }:</b>
                          </td>`+
                       `  <td style="text-align: right;color: ${ this.points[index].color }">`+
                       `    &nbsp;&nbsp;
                            ${ $filter('number')(this.points[index].y) }&nbsp
                            ${ (data[0].marker || data[0].objeto).unitDescription}
                          </td>`+
                       '</tr>';
                }
                s += '  </tbody>'+
                     '</table>';
                return s;
              },
              valueDecimals: 0,
              crosshairs: {
                width: 2,
                color: 'gray',
                dashStyle: 'shortdot'
              },
              backgroundColor: {
                linearGradient: [0, 0, 0, 60],
                stops: [
                  [0, '#E0E0E0'],
                  [1, '#FFFFFF']
                ]
              },
              borderRadius: 10,
              borderColor: 'black',
              borderWidth: 1,
              shared: true
            },
            series: [
              {
                name: 'Realizada',
                data: serie2,
                type: 'column'
              },
              {
                name: isProdutividade ? 'Meta' : 'Ideal',
                data: serie1,
                type: 'line',
                color: '#888888',
                marker: {
                  enabled: false
                }
              }
            ]
          });
          $timeout(function() {
            _this.adjustChart(container, containerChart);
          }, 1000);
        });
      }
    },

    // eslint-disable-next-line max-lines-per-function
    loaderStandDistribution: function(data, container, containerChart) {
      if ($(containerChart).highcharts()) {
        $(containerChart).highcharts()
          .destroy();
      }

      if (data.length > 0) {
        data = removeInactiveStands(data);

        const uniformidade = data.map(function(marker) {
          return marker.objeto.uniformidadeDistribuicao;
        });

        const _this = this;

        // eslint-disable-next-line max-lines-per-function
        $(function() {
          $(containerChart).highcharts({
            chart: {
              backgroundColor: null,
              spacingLeft: 5,
              spacingRight: 5,
              spacingBottom: 5
            },
            credits: { text: '', href: '' },
            title: { text: '' },
            subtitle: { text: '' },
            xAxis: { tickInterval: 1 },
            yAxis: {
              title: {
                text: ''
              },
              gridLineColor: '#6D869F',
              labels: {
                align: 'right',
                x: 0,
                y: 0
              }
            },
            legend: {
              enabled: false
            },
            plotOptions: {
              series: {
                fillOpacity: 0.2,
                pointStart: 1,
                cursor: 'pointer',
                point: {
                  events: {
                    click: () => null
                  }
                }
              }
            },
            tooltip: {
              useHTML: true,
              formatter: function() {
                let s = `${'<table>'+
                        '  <thead>'+
                        '    <tr><th colspan="2" style="text-align:center">'+
                        '     <h5><b>Ponto '}${ this.x }</b></h5></th>`+
                        '    </tr>'+
                        '  </thead>'+
                        '  <tbody>';
                for (const index in this.points) {
                  s += `${'<tr>'+
                       '  <td style="text-align: right;"><b>'}${ this.points[index].series.name }:</b></td>`+
                       '  <td style="text-align: right;">'+
                       `    &nbsp;&nbsp; ${ $filter('number')(this.points[index].y, 2) }%` +
                       '  </td>'+
                       '</tr>';
                }
                s += '  </tbody>'+
                     '</table>';
                return s;
              },
              valueDecimals: 0,
              crosshairs: {
                width: 2,
                color: 'gray',
                dashStyle: 'shortdot'
              },
              backgroundColor: {
                linearGradient: [0, 0, 0, 60],
                stops: [
                  [0, '#E0E0E0'],
                  [1, '#FFFFFF']
                ]
              },
              borderRadius: 10,
              borderColor: 'black',
              borderWidth: 1,
              shared: true
            },
            series: [
              {
                name: 'Uniformidade',
                data: uniformidade,
                type: 'column'
              }
            ]
          });
          $timeout(function() {
            _this.adjustChart(container, containerChart);
          }, 1000);
        });
      }
    }
  };
});
